var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExclamation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Exclamacion",
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_262",
    "data-name": "Rect\\xE1ngulo 262",
    width: 40,
    height: 40,
    rx: 8,
    fill: "rgba(255,255,255,0)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Exclamacio\\u0301n",
    transform: "translate(6.667 8.332)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_328",
    "data-name": "Trazado 328",
    d: "M12.638,8.188H11.589V18.718h1.049Z",
    transform: "translate(1.212 -1.405)",
    fill: "#2d6df6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_329",
    "data-name": "Trazado 329",
    d: "M18.137,22.752H4.7a1.66,1.66,0,0,1-1.2-.477,1.493,1.493,0,0,1-.456-1.06,1.421,1.421,0,0,1,.194-.713l4.029-7.072.519-.913a1.081,1.081,0,0,0-1.422.372l-4.04,7.088A2.472,2.472,0,0,0,2,21.21a2.55,2.55,0,0,0,.771,1.8,2.757,2.757,0,0,0,1.936.776H19.139a1.045,1.045,0,0,0-1-1.044Z",
    transform: "translate(-2 0.001)",
    fill: "#2d6df6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_330",
    "data-name": "Trazado 330",
    d: "M26.78,23.1,16.157,4.455a2.6,2.6,0,0,0-1.039-1.013,2.833,2.833,0,0,0-2.676,0A2.669,2.669,0,0,0,11.4,4.455l-4.27,7.5-.519.913a1.081,1.081,0,0,0,1.422-.372L12.322,4.98a1.579,1.579,0,0,1,.624-.609,1.778,1.778,0,0,1,.839-.21,1.719,1.719,0,0,1,.839.21,1.579,1.579,0,0,1,.624.609L25.873,23.62a1.421,1.421,0,0,1,.194.714,1.515,1.515,0,0,1-.456,1.06,1.7,1.7,0,0,1-1.2.477H19.635a1.045,1.045,0,0,0,1,1.044h3.783a2.754,2.754,0,0,0,1.936-.771,2.529,2.529,0,0,0,.771-1.8,2.473,2.473,0,0,0-.33-1.233Z",
    transform: "translate(-0.454 -3.107)",
    fill: "#2d6df6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_331",
    "data-name": "Trazado 331",
    d: "M11.393,17.845a.786.786,0,0,0,.231.556.785.785,0,1,0-.231-.556Z",
    transform: "translate(1.146 1.566)",
    fill: "#2d6df6"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExclamation);
export default __webpack_public_path__ + "static/media/exclamation.aeaec109.svg";
export { ForwardRef as ReactComponent };